import { useState, useEffect, RefObject } from 'react';

export function useElementScrollDistanceFromTopThreshold({
  ref,
  threshold,
}: {
  ref: RefObject<HTMLElement>;
  threshold: number;
}): boolean {
  const [isPastThreshold, setIsPastThreshold] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (ref.current) {
        setIsPastThreshold(
          ref.current.getBoundingClientRect().top <= threshold
        );
      }
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [ref, threshold]);

  return isPastThreshold;
}
